import React, { useState } from "react";
import { FFmpeg } from "@ffmpeg/ffmpeg";

const AudioConverter = () => {
  const [ffmpeg] = useState(new FFmpeg());
  const [loaded, setLoaded] = useState(false);
  const [file, setFile] = useState(null);
  const [outputUrl, setOutputUrl] = useState(null);

  const loadFFmpeg = async () => {
    if (!ffmpeg.loaded) {
      await ffmpeg.load();
      setLoaded(true);
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files?.item(0));
  };

  const convertToMp3 = async () => {
    if (!file) return;

    await loadFFmpeg();

    // Write file into memory
    await ffmpeg.writeFile(file.name, await fetch(file).then(r => r.arrayBuffer()));

    // Run conversion
    await ffmpeg.exec(["-i", file.name, "output.mp3"]);

    // Read the result
    const data = await ffmpeg.readFile("output.mp3");

    // Create Blob and URL
    const url = URL.createObjectURL(new Blob([data.buffer], { type: "audio/mpeg" }));
    setOutputUrl(url);
  };

  return (
    <div className="p-4">
      <h2 className="text-lg font-bold">Audio Converter</h2>
      <input type="file" accept="audio/*" onChange={handleFileChange} />
      <button
        onClick={convertToMp3}
        className="bg-blue-500 text-white p-2 rounded mt-2"
      >
        Convert to MP3
      </button>

      {outputUrl && (
        <div className="mt-4">
          <audio controls src={outputUrl}></audio>
          <a href={outputUrl} download="output.mp3" className="ml-4 text-blue-600 underline">
            Download MP3
          </a>
        </div>
      )}
    </div>
  );
};

export default AudioConverter;
